<template>
    <div class="mx-2  pt-2 py-2" style="height: 90vh;">
        <h1 class="flex justify-center text-2xl 100vh  mb-5 pt-10 ">Create SoP</h1>
        <form class="max-w-md mx-auto" @submit.prevent="submit">
            <div class="mb-5">
                <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                     Note</label>
                <input type="text" v-model="note" id="username"
                    class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                    placeholder="Note"  />
            </div>
                <div class="flex flex-wrap items-baseline mb-5" >
                    <label class="block w-[150px]  text-sm text-bg-save font-medium  text-[17px] dark:text-white"
                        for="file_input">Select
                        File (pdf or docx)</label>
                    <input @change="handleFileUpload"
                        class="block w-full text-sm md:mx-0 mx-4 text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                        aria-describedby="file_input_help" id="file_input" type="file">
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-300" id="file_input_help"></p>
                </div>
            <div class="flex items-center mt-5 justify-between">
                <router-link to="sops"
                        class="text-white mb-5  bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        Back</router-link>
                    <button type="submit"
                        class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        Create New SOP</button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUpdated } from 'vue';
import Swal from 'sweetalert2';
import axiosInstce from "@/plugins/axios"
import { useRouter } from 'vue-router';
import axiosInstance from "@/plugins/axios"
const pageLoader = ref(false);

const router = useRouter(); // Initialize the router object


const permissions = ref()
const permissionid = ref([])
const note = ref()
const session_time = ref()
const getPermission = () => {
    axiosInstce.get(`/permissions`)
        .then(response => {
            // console.log('Hospitals API response:', response.data.data.permissions);
            permissions.value = response.data.data.permissions
        })
        .catch(error => {
            console.error('Error fetching hospitals:', error);
        });
}

// const handleFileUpload = (event) => {
//   const file = event.target.files[0];
//   uploadFile(file);
// };

const uploadFile = async (file) => {
  pageLoader.value = true;
  try {
    const formData = new FormData();
    formData.append('note',note.value)
    formData.append('file', file);

    const response = await axiosInstance.post('/sops', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    pageLoader.value = false;

    Swal.fire({
      icon: 'success',
      title: 'SoPs imported successfully',
      text: ''
    });
    router.push({ name: 'sops' });
  } catch (error) {
    pageLoader.value = false;
    Swal.fire({
      icon: 'warning',
      title: 'SoPs import failed',
      text: error.response.data.message
    });
  }
};
const submit = async () => {
  const fileInput = document.getElementById('file_input');
  const file = fileInput.files[0];

  // Check if a file is selected
  if (!file) {
    Swal.fire({
      icon: 'warning',
      title: 'Please select a file',
      text: 'You need to choose a file before submitting.'
    });
    return;
  }

  // Call the uploadFile function with the selected file
  await uploadFile(file);
};

</script>